// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.controls-wrapper {
  display: flex;
  flex-flow: row nowrap;
  max-width: fit-content;
  background-color: white;
  color: var(--color-text-dark);
  border-radius: var(--border-radius);
  gap: 2rem;
  padding: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/map.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,mCAAmC;EACnC,SAAS;EACT,aAAa;AACf","sourcesContent":[".controls-wrapper {\n  display: flex;\n  flex-flow: row nowrap;\n  max-width: fit-content;\n  background-color: white;\n  color: var(--color-text-dark);\n  border-radius: var(--border-radius);\n  gap: 2rem;\n  padding: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
